import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const StyledContent = styled.div`
  width: 25rem;
  margin: -0.75rem -1rem;
`;

export const StyledList = styled.ul`
  padding-left: 0;
  list-style-type: none;
  margin: 0;
  max-height: 300px;
  overflow-y: auto;
`;

interface LiProps {
  $hasLink?: boolean;
  $unread?: boolean;
}

export const StyledItem = styled.li<LiProps>`
  background: ${({ theme }) => theme.secondaryBackgroundColor};
  color: ${({ theme }) => theme.textColor};
  padding: ${({ $hasLink }) => ($hasLink ? 0 : '1rem')};
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  display: flex;
  align-items: center;
  ${({ $unread }) =>
    $unread
      ? css`
          font-weight: bold;
        `
      : ''};
  .anticon.status-icon {
    align-self: flex-start;
    margin: 0.3rem 1rem 0 0;
    position: relative;
    ${({ $unread }) =>
      $unread
        ? css`
            &::after {
              content: '';
              width: 0.75rem;
              height: 0.75rem;
              background: ${({ theme }) => theme.teal};
              display: block;
              bottom: -2px;
              position: absolute;
              right: -2px;
              border-radius: 50%;
            }
          `
        : ''};
  }
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const StyledLink = styled(Link)`
  padding: 1rem;
  color: inherit;
  width: 100%;
  display: flex;
  &:hover {
    color: inherit;
    background-color: ${({ theme }) => theme.tealBackgroundColor};
  }
`;

export const StyledHeader = styled.span`
  color: ${({ theme }) => theme.headerColor};
  text-transform: uppercase;
`;

export const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  background-color: ${({ theme }) => theme.tertiaryBackgroundColor};
`;

export const StyledMessage = styled.div`
  flex: 1;
  p {
    margin-bottom: 0;
  }
`;

export const StyledDate = styled.p`
  font-size: 0.75rem;
  flex: 0 0 auto;
  align-self: flex-start;
  margin-top: 0.1rem;
`;
